export default "__VITE_ASSET__Cs0ECwEe__"